import { Colors } from "@fuse/styles/color";
import { FunctionComponent } from "react";

interface OutlineBtnProps {
  label: string;
  className?: string;
  style?: React.CSSProperties;
  labelClassName?: string;
  onClick?: () => void;
}

const OutlineBtn: FunctionComponent<OutlineBtnProps> = ({
  label,
  className,
  style,
  labelClassName,
  onClick,
}) => {
  const styles: React.CSSProperties = {
    borderWidth: 2,
    borderColor: Colors.grey,
    color: Colors.secondary,
    backgroundColor: "#fff",
    borderRadius: 30,
  };
  const btnText: React.CSSProperties = {
    fontFamily: "DM Sans",
  };

  return (
    <button
      style={{ ...styles, ...style }}
      className={"" + className}
      onClick={onClick}
    >
      <h4
        style={btnText}
        className={"text-[15px] md:text-[20px]" + labelClassName}
      >
        {label}
      </h4>
    </button>
  );
};

export default OutlineBtn;
